import { adminApi } from "../../lib/axios";

export type AutomationMetric = "AFFILIATES" | "REVENUE";

export interface MilestoneConfigurationRule {
  id: string;
  type: AutomationMetric;
  threshold: number;
  isActive: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface AffiliateRewardConfigurationRule {
  id: string;
  reward: string;
  threshold: number;
  isActive: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateEmailAutomationRuleInput
  extends Omit<MilestoneConfigurationRule, "id" | "createdAt" | "updatedAt"> {}

export interface UpdateEmailAutomationRuleInput
  extends Partial<
    Omit<MilestoneConfigurationRule, "id" | "createdAt" | "updatedAt">
  > {}

export const adminEmailAutomationsService = {
  async list(): Promise<MilestoneConfigurationRule[]> {
    try {
      const res = await adminApi.get("/milestone/config");
      return res.data.data || res.data.items || res.data || [];
    } catch (error: any) {
      console.error("Error fetching email automation rules:", error);
      return [];
    }
  },

  async create(
    input: CreateEmailAutomationRuleInput
  ): Promise<MilestoneConfigurationRule> {
    const res = await adminApi.post("milestone/config", input);
    return res.data.data || res.data.item || res.data;
  },

  async update(
    id: string,
    input: UpdateEmailAutomationRuleInput
  ): Promise<MilestoneConfigurationRule> {
    const res = await adminApi.patch(`milestone/config/${id}`, input);
    return res.data.data || res.data.item || res.data;
  },

  async remove(id: string): Promise<{ success: boolean; message?: string }> {
    const res = await adminApi.delete(`milestone/config/${id}`);
    return { success: true, message: res.data?.message };
  },
};

export default adminEmailAutomationsService;
